import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "@fox1ck-org/auth/react";
import { brandDefaultThemeOf, getBrand, loadBrand } from "@fox1ck-org/auth/saas";
import { ThemeProvider } from "@fox1ck-org/ui/theme";
import { QueryProvider } from "@/components/providers/query-provider";
import { auth, runtimeConfig } from "@/lib/auth";
import { DEFAULT_DENSITY, DEFAULT_THEME, THEME_STORAGE_KEY } from "@/shell/appearance";
import App from "./App";
import "./app.css";

/**
 * The org's brand by host, before the first frame (card S11b): a customer's
 * own host (track.<their domain>) opens in their name and colours. A cached
 * answer paints at once; otherwise console is waited for at most 1.5 s — a
 * slow console means the Vibe theme, never a blank app. On a shared host the
 * shell looks the brand up by the signed-in org (`useBrand`).
 */
const brand = runtimeConfig.consoleUrl ? loadBrand({ consoleUrl: runtimeConfig.consoleUrl }).catch(() => null) : Promise.resolve(null);

void brand.then(() => {
  // The brand's default theme (console data) until the person picks one.
  const defaultTheme = brandDefaultThemeOf(getBrand().brand) ?? DEFAULT_THEME;
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <ThemeProvider storageKey={THEME_STORAGE_KEY} defaultTheme={defaultTheme} defaultDensity={DEFAULT_DENSITY}>
        <QueryProvider>
          <AuthProvider auth={auth}>
            <App />
          </AuthProvider>
        </QueryProvider>
      </ThemeProvider>
    </StrictMode>,
  );
});
